import api from '@/api/targets'
import { errorHandler } from "../exports/error_management"
import { buildQuery } from '../exports/queryStringBuilder'
import axios from 'axios'
const state = {
    targets: null,
    drivers: [],
    items: [],
    items_not_paginated: [],
    pagination: null,
    filter: null,
    query: null,
    monthly_record_company: null,
    monthly_record_officer: null,
    target_progress: null,
    value_progress: null,
    activities: null,
    month_data: null,
    months_data: null,
    month_data_officer: null,
    months_data_officer: null,
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    set_items_not_paginated(state, payload) {
        state.items_not_paginated = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
    set_vehicle(state, targets) {
        state.targets = targets
    },
    set_drivers(state, drivers) {
        state.drivers = drivers
    },
    updateFilter(state, payload) {

        state.filter = payload.filters;
        state.query = payload.query;
    },
    set_month_record(state, targets) {
        console.log('this is payload-----------', targets);
        state.monthly_record_company = targets;
    },
    set_month_record_officer(state, targets) {
        console.log('this is payload-----------', targets);
        state.monthly_record_officer = targets;
    },
    set_target_progress(state, targets) {
        state.target_progress = targets;
    },
    set_value_progress(state, targets) {
        state.value_progress = targets;
    },
    set_activity(state, targets) {
        state.activities = targets;
    },
    set_target_progress_officer(state, targets) {
        state.target_progress_officer = targets;
    },
    set_value_progress_officer(state, targets) {
        state.value_progress_officer = targets;
    },
    set_month_record_for_modal(state, targets) {
        state.month_data = targets;
    },
    set_months_record_for_modal(state, targets) {
        state.months_data = targets;
    },
    set_month_record_for_modal_officer(state, targets) {
        state.month_data_officer = targets;
    },
    set_months_record_for_modal_officer(state, targets) {
        state.months_data_officer = targets;
    },
}

const actions = {
    duplicate(context, payload) {
        return api
            .duplicate(payload)
            .then(() => { })
            .catch(err => {
                errorHandler(err)
            })
    },
    bulkDelete(context, payload) {
        return api
            .bulkDelete(payload)
            .then(() => { })
            .catch(err => {
                errorHandler(err)
            })
    },
    create(context, payload) {
        return api
            .create(payload)
            .then(() => { })
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchById(context, id) {
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_vehicle', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    getTargetProgress(context, payload) {
        console.log('this is payload', payload);
        return api
            .getTargetProgress(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_target_progress', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            });
    },
    getValueProgress(context, payload) {
        console.log('this is payload', payload);
        return api
            .getValueProgress(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_value_progress', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            });
    },
    getTargetProgressOfficer(context, payload) {
        console.log('this is payload', payload);
        return api
            .getTargetProgressOfficer(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_target_progress_officer', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            });
    },
    getValueProgressOfficer(context, payload) {
        console.log('this is payload', payload);
        return api
            .getValueProgressOfficer(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_value_progress_officer', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            });
    },
    fetchActivity(context, payload) {
        console.log('this is payload', payload);
        return api
            .fetchActivity(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_activity', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            });

    },
    getYearRecord(context, payload) {
        console.log('this is payload', payload);
        return api
            .getYearRecord(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_month_record', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    getModelDataForMonth(context, payload) {
        console.log('this is payload', payload);
        return api
            .getModelDataForMonth(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_month_record_for_modal', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    getModelDataForMonthOfficer(context, payload) {
        console.log('this is payload', payload);
        return api
            .getModelDataForMonthOfficer(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_month_record_for_modal_officer', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    getModelDataByMonth(context, payload) {
        console.log('this is payload', payload);
        return api
            .getModelDataByMonth(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_months_record_for_modal', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    getModelDataByMonthOfficer(context, payload) {
        console.log('this is payload', payload);
        return api
            .getModelDataByMonthOfficer(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_months_record_for_modal_officer', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    getYearRecordOfficer(context, payload) {
        console.log('this is payload', payload);
        return api
            .getYearRecordOfficer(payload.filter)
            .then(
                ({
                    data: {
                        success: { data: targets },
                    },
                }) => {
                    console.log('store vehecddddd', targets)
                    context.commit('set_month_record_officer', targets)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchUsers(context) {
        //const driver_role_id = 2
        return api
            .fetchDrivers()
            .then(
                ({
                    data: {
                        success: {
                            data: { data: drivers },
                        },
                    },
                }) => {
                    /*  console.log('drivers', drivers)
                    drivers = drivers.filter(
                        x => !!x.roles.find(r => r.role_id == driver_role_id)
                    ) */
                    context.commit('set_drivers', drivers)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchAll(context) {

        return api
            .fetchNames()
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {

                    let items = pag

                    context.commit('set_items_not_paginated', items)

                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    fetch(context, payload) {
        console.log('payload-', payload)
        return api
            .fetch(payload.query, payload.page, payload.filters)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    if (payload.page && payload.page > 0) {
                        console.log('pag', pag)
                        let users = pag.data

                        context.commit('set', users)
                        //let pag = result.data.success.data
                        context.commit('set_pagination', {
                            page: pag.current_page,
                            pageSize: pag.per_page,
                            total: pag.total,
                        })
                    } else {
                        console.log('pag', pag)
                        let items = pag

                        context.commit('set_items_not_paginated', items)
                    }
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    update(context, payload) {
        console.log('update', payload)
        return api
            .update(payload.id, payload)
            .then(() => { })
            .catch(err => {
                errorHandler(err)
            })
    },
    delete(context, id) {
        return api
            .delete(id)
            .then(() => {
                context.commit('delete', id)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    async getModelDataForMonthExcel(context, payload) {
        try {

            var filter_target = payload.filter || '';

            const response = await axios.get(`targets/get-month-record-excel?` + buildQuery(filter_target), {
                responseType: 'blob'
            })
            const blob = new Blob([response.data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "targets.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error fetching request:", err);
        }

    },

    async getModelDataByMonthExcel(context,payload){
        try {

            var filter_target = payload.filter || '';

            const response = await axios.get(`targets/get-months-record-excel?` + buildQuery(filter_target), {
                responseType: 'blob'
            })
            const blob = new Blob([response.data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "targets.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error fetching request:", err);
        }

    },

    async getModelDataForMonthOfficerExcel(context,payload){

        try {

            var filter_target = payload.filter || '';

            const response = await axios.get(`targets/get-month-record-officer-excel?` + buildQuery(filter_target), {
                responseType: 'blob'
            })
            const blob = new Blob([response.data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "targets.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error fetching request:", err);
        }

    },
    async getModelDataByMonthOfficerExcel(context,payload){

        try {

            var filter_target = payload.filter || '';

            const response = await axios.get(`targets/get-months-record-officer-excel?` + buildQuery(filter_target), {
                responseType: 'blob'
            })
            const blob = new Blob([response.data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "targets.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error fetching request:", err);
        }

    },
    async exportExcelCSV(context, { query_target, filter_target }) {
        try {
            query_target = query_target || '';
            filter_target = filter_target || '';
            console.log('filters are ', filter_target);
            const response = await axios.get(`targets/export-excel-csv?q=${query_target}&` + buildQuery(filter_target), {
                responseType: 'blob'
            })
            const blob = new Blob([response.data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "targets.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error fetching request:", err);
        }
    },
    async exportExcelData(context, { query_target, filter_target }) {
        try {
            query_target = query_target || '';
            filter_target = filter_target || '';
            console.log('filters are ', filter_target);
            const response = await axios.get(`targets/export-excel?q=${query_target}&` + buildQuery(filter_target), {
                responseType: 'blob'
            })
            const blob = new Blob([response.data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "targets.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error fetching request:", err);
        }
    },
    async upload(context, payload) {
        try {
            console.log('payload is --------', payload);
            const results = await axios.post(`targets/upload`, payload)

            if (!results) return results.data.success.data || results.data.error

            // return data
        } catch (err) {
            errorHandler(err)
        }
    },

}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}